export default "__VITE_ASSET__gMhBH8IF__"